import { ReactElement } from "react";
import Form from "@ui-kit/form/Form/Form.web";
import { QuantitySelectIncrementorProps } from "./QuantitySelectIncrementor.props";

export default function QuantitySelectIncrementor(
  props: QuantitySelectIncrementorProps
): ReactElement {
  const {
    dataTestId,
    isDisabled,
    currentSelectedAmount,
    min,
    max,
    callbackFunc,
  } = props;

  return (
    <Form.Incrementer
      data-testid={dataTestId ?? "quantity-select-incrementor"}
      height="element.3xl"
      width="100%"
      size="md"
      isDisabled={isDisabled}
      value={currentSelectedAmount}
      onChange={callbackFunc}
      min={min}
      max={max}
    />
  );
}
